import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { environment } from './../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable()
export class AtivacaoServicesListaService {
    private baseUrlService: string;

    constructor(private http: HttpClient) {
        this.baseUrlService = environment.URL_API;
    }

    public ativacaoServicoAlteraVisibilidade(path: string):Observable<any>{
        const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: currentUser.token
          })};
        return this.http.put(`${this.baseUrlService}/${path}`, {}, httpOptions);
    }

}
